import React from "react";
import "./footer.css"
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaPinterestP, FaInstagram, FaYoutube, FaWhatsapp, FaPhoneAlt} from "react-icons/fa";

const Footer = () => {
  return (
    <>
      <section id="bottom">
        <div className="Container clearfix">
          <div className="disclaimerTxt">
            <span>
              Disclaimer<sup>*</sup>
            </span>
            No guarantee is given for the best results to All. Results may vary
            from person to person, owing to some uncontrollable reasons.
          </div>
        </div>
        <div className="Container clearfix">
          <div className="bottomFirstCol">
            I <span>Shared</span> My <span>Knowledge</span> To <span>Help</span>{" "}
            People
          </div>
          <div className="clientsBar">
            <a
              href="https://www.astrologerankitsharma.com/client-success-stories/"
              className="blinker"
            >
              Clients Success Stories !
            </a>
          </div>
          <div className="bottomSecondCol">
            <span>CONTACT ASTROLOGER ANKIT SHARMA</span>
            <p>
              <i>Mohali</i> : House No.335, Phase 3A, Mohali 160059
            </p>
            <p>
              <i>Delhi</i> : Shivaji Vihar, Rajouri Garden, New Delhi-110015
            </p>
            <p>
              <i>Chandigarh</i> : Near Women College, Top Floor, Sector 46,
              Chandigarh-160046, Punjab
            </p>
            <i>Mode of Payment</i> : <br />
            <p>
              <b>For India :</b> Bank Transfer
              <br />
              <b>International :</b> PayPal, Western Union, Bank Transfer, Money
              Gram
            </p>
            <p>
              <i>Mobile/WhatsApp/Viber</i> :{" "}
              <em>
                <a href="tel:+91-98154-18307" className="tel">
                  +91-98154-18307
                </a>
              </em>
              <br />
              <i>Email</i> :{" "}
              <a href="mailto:info@astrologerankitsharma.com">
                info@AstrologerAnkitSharma.com
              </a>
              <br />
              <i>Skype</i> : Ankit.sharma3291
              <br />
            </p>
          </div>
          <div className="bottomThirdCol">
            <div className="socialSection">
              <span>FOLLOW GURUJI AT SOCIAL MEDIA</span>
              <ul className="clearfix">
                <li>
                  <a
                    href="https://www.facebook.com/Astrologer.Ankit.Sharma/"
                  >
                    <FaFacebookF />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/c/AstrologerAnkitSharma"
                  >
                    <FaYoutube />
                  </a>
                </li>
                <li>
                  <a
                    href="https://twitter.com/astrologerankit"
                  >
                    <FaTwitter />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/company/astrologer-ankit-sharma-ji/"
                  >
                    <FaLinkedinIn />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.pinterest.com/astrologerankit/"
                  >
                    <FaPinterestP />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/Astrologer.Ankit.Sharma/"
                  >
                    <FaInstagram />
                  </a>
                </li>
                <li>
                  <a
                    href="https://mojapp.in/@astrologerankitsharma"
                  >
                    <img
                      src="https://www.astrologerankitsharma.com/images/new/moj-icon.png"
                      alt="Moj App"
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="https://sharechat.com/profile/astrologer_ankit_sharma"
                  >
                    <img
                      src="https://www.astrologerankitsharma.com/images/new/sharechat-icon.png"
                      alt="Share Chat"
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.kooapp.com/profile/Astrologer.Ankit.Sharma"
                  >
                    <img
                      src="https://www.astrologerankitsharma.com/images/new/kooapp-icon.png"
                      alt="KooApp"
                    />
                  </a>
                </li>
              </ul>
            </div>
            <div className="dmca">
              <div className="dmcatitle">Do Not Copy Without Permission</div>
              <div>
                <script src="//images.dmca.com/Badges/DMCABadgeHelper.min.js"></script>
                <a
                  href="//www.dmca.com/Protection/Status.aspx?ID=50ac2b1e-0abf-4575-9dbc-616c7b66271e"
                  title="DMCA.com Protection Program"
                  className="dmca-badge"
                >
                  <img
                    src="https://images.dmca.com/Badges/_dmca_premi_badge_1.png?ID=50ac2b1e-0abf-4575-9dbc-616c7b66271e"
                    alt="DMCA.com Protection Status"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer>
        <div className="Container clearfix">
          <div className="flinks">
            <ul className="clearfix">
              <li>
                <a href="https://www.astrologerankitsharma.com/profile.html">
                  Profile
                </a>
              </li>
              <li>
                <a href="https://www.astrologerankitsharma.com/infographics/">
                  Infographics
                </a>
              </li>
              <li>
                <a href="https://www.astrologerankitsharma.com/testimonials.html">
                  Testimonial
                </a>
              </li>
              <li>
                <a href="https://www.astrologerankitsharma.com/disclaimer.html">
                  Disclaimer
                </a>
              </li>
              <li>
                <a href="https://www.astrologerankitsharma.com/privacy-policy.html">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="https://www.astrologerankitsharma.com/sitemap.html">
                  Sitemap
                </a>
              </li>
              <li>
                <a href="https://www.astrologerankitsharma.com/faq-vashikaran/">
                  FAQ
                </a>
              </li>
            </ul>
          </div>
          <div className="fTxt">
            Copyright &copy; 2022 All Rights Reserved
            AstrologerAnkitSharma(dot)(com)
          </div>
        </div>
      </footer>
      <a href="tel:+91-98154-18307" id="callNowButton">
        <FaPhoneAlt />
      </a>
      <a
        href="https://api.whatsapp.com/send?phone=919815418307&amp;text=I%20want%20your%20services."
        id="whatsAppButt"
      >
        <FaWhatsapp />
      </a>
    </>
  );
};

export default Footer;
